import { render, staticRenderFns } from "./CampaignSetupsSummaryModal.vue?vue&type=template&id=3a85e836"
import script from "./CampaignSetupsSummaryModal.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsSummaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports